<template>
  <v-menu
    ref="dateMenu"
    v-model="isDateMenuOpen"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        ref="refDateTextValue"
        autocomplete="off"
        :value="dateTextValue"
        @change="onDateTextChange($event)"
        :label="label"
        :outlined="outlined"
        :disabled="disabled"
        v-mask="'##/##/####'"
        prepend-icon='event'
        :placeholder="placeholder"
        :hint="hint"
        :rules="rules"
        v-bind="attrs"
        persistent-hint
        @blur="onDateTextBlur()"
        v-on="on"
        @keydown.enter="$emit('keydown', $event)"
        :dense="dense"
        :autofocus="autofocus"
        :clearable="clearable"
      >
      </v-text-field>
    </template>
    <v-date-picker
      v-model="datePickerValue"
      no-title
      @input="isDateMenuOpen = false"
      @change="onDatePickerChange($event)"
      locale="es-es"
    ></v-date-picker>
  </v-menu>
</template>
<script>
/**
 * Componente que integra un text-field con un date-picker y permite ingresar fechas en format DD/MM/YYYY
 */
// import { VInput } from 'vuetify/lib/components'
const moment = require('moment');

export default {
  name: 'GlobalDateInputPicker',
  // extends: VInput,
  props: {
    /**
     * Si es que se desea setear datos mediante v-model, el formato debe ser: DD/MM/YYYY
     */
    model: {
      type: String,
      default: null
    },
    /**
     * Label o título del campo de texto
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Placeholder del campo de texto
     */
    placeholder: {
      type: String,
      default: null
    },
    /**
     * Hint del campo de texto
     */
    hint: {
      type: String,
      default: null
    },
    /**
     * Rules en caso de que hayan
     */
    rules: {
      type: Array,
      default: () => ([])
    },
    /**
     * Outlined en caso de que se quiera con borde redondeado
     */
    outlined: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Disabled en caso de que se quiera el componente deshabilitado
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  data: () => ({
    datePickerValue: null,
    dateTextValue: null,
    isDateMenuOpen: false
  }),
  async created () {
    await this.obtainFromModel();
  },
  methods: {
    async obtainFromModel () {
      if (this.model) {
        const part = this.model.split('/');
        // No es un valor correcto
        if (part.length === 3) {
          if (moment(this.model, 'DD/MM/YYYY').isValid()) {
            this.datePickerValue = await this.formatDateYYYYMMDD(this.model);
            this.dateTextValue = await this.formatDateDDMMYYYY(this.datePickerValue);
          } else {
            this.limpiarTodo();
          }
        } else {
          this.limpiarTodo();
        }
      } else {
        this.limpiarTodo();
      }
    },
    onDatePickerChange (event) {
      this.dateTextValue = this.formatDateDDMMYYYY(event);
      this.$emit('change', this.dateTextValue);
    },
    onDateTextChange (event) {
      if (event) {
        const part = event.split('/');
        // No es un valor correcto
        if (part.length === 3) {
          if (moment(event, 'DD/MM/YYYY').isValid()) {
            this.dateTextValue = event;
            this.isDateMenuOpen = false;
            this.$emit('change', this.dateTextValue);
          } else {
            this.limpiarTodo();
          }
        } else {
          this.limpiarTodo();
        }
      } else {
        this.limpiarTodo();
      }
    },
    onDateTextBlur () {
      if (this.dateTextValue) {
        const part = this.dateTextValue.split('/');
        // No es un valor correcto
        if (part.length === 3) {
          if (moment(this.dateTextValue, 'DD/MM/YYYY').isValid()) {
            this.datePickerValue = this.formatDateYYYYMMDD(this.dateTextValue);
          } else {
            this.limpiarTodo();
          }
        } else {
          this.limpiarTodo();
        }
      // } else {
      //   this.limpiarTodo();
      }
    },
    formatDateDDMMYYYY (date) {
      if (!date) {
        return null;
      }
      if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      } else {
        return date;
      }
    },
    limpiarTodo () {
      this.dateTextValue = null;
      this.datePickerValue = null;
      this.resetDateTextValue();
      this.$emit('change', null);
    },
    resetDateTextValue () {
      if (this.$refs.refDateTextValue) {
        this.$refs.refDateTextValue.reset();
      }
    },
    formatDateYYYYMMDD (date) {
      try {
        if (!date) return null;
        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      } catch (error) {
        console.error('Fecha inválida');
        return null;
      }
    }
  },
  watch: {
    model: function (val, oldVal) {
      if (val !== this.dateTextValue) {
        this.obtainFromModel();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/common/util/GlobalDateInputPicker.vue